var selectric = function() {
  var $ = require('jquery');
  require('jquery-selectric');

  $("select").selectric({disableOnMobile: false});

  $(".property-filters ul li").click(function() {
      console.log($(this));
      var url = $(".property-filters select").val();
      if (url) { window.location = url; }
      return false;
  });

}
module.exports = selectric;